import { i18n } from '@fs/zion-locale'

const relationshipOptions = [
  { value: 'AUNT', label: i18n.t('avatar.family.aunt', 'Aunt'), gender: 'FEMALE', relationship: 'AUNT' },
  { value: 'SIBLING_MALE', label: i18n.t('avatar.family.brother', 'Brother'), gender: 'MALE', relationship: 'SIBLING' },
  {
    value: 'COUSIN_UNKNOWN',
    label: i18n.t('avatar.family.cousin', 'Cousin'),
    gender: 'UNKNOWN',
    relationship: 'COUSIN',
  },
  {
    value: 'CHILD_FEMALE',
    label: i18n.t('avatar.family.daughter', 'Daughter'),
    gender: 'FEMALE',
    relationship: 'CHILD',
  },
  { value: 'PARENT_MALE', label: i18n.t('avatar.family.father', 'Father'), gender: 'MALE', relationship: 'PARENT' },
  {
    value: 'FRIEND_UNKNOWN',
    label: i18n.t('avatar.family.friend', 'Friend'),
    gender: 'UNKNOWN',
    relationship: 'FRIEND',
  },
  {
    value: 'GRANDCHILD_FEMALE',
    label: i18n.t('avatar.family.granddaughter', 'Granddaughter'),
    gender: 'FEMALE',
    relationship: 'GRANDCHILD',
  },
  {
    value: 'GRANDPARENT_MALE',
    label: i18n.t('avatar.family.grandfather', 'Grandfather'),
    gender: 'MALE',
    relationship: 'GRANDPARENT',
  },
  {
    value: 'GRANDPARENT_FEMALE',
    label: i18n.t('avatar.family.grandmother', 'Grandmother'),
    gender: 'FEMALE',
    relationship: 'GRANDPARENT',
  },
  {
    value: 'GRANDCHILD_MALE',
    label: i18n.t('avatar.family.grandson', 'Grandson'),
    gender: 'MALE',
    relationship: 'GRANDCHILD',
  },
  {
    value: 'GREAT_GRANDPARENT_MALE',
    label: i18n.t('avatar.family.great-grandfather', 'Great-Grandfather'),
    gender: 'MALE',
    relationship: 'GREAT_GRANDPARENT',
  },
  {
    value: 'GREAT_GRANDPARENT_FEMALE',
    label: i18n.t('avatar.family.great-grandmother', 'Great-Grandmother'),
    gender: 'FEMALE',
    relationship: 'GREAT_GRANDPARENT',
  },
  { value: 'SPOUSE_MALE', label: i18n.t('avatar.family.husband', 'Husband'), gender: 'MALE', relationship: 'SPOUSE' },
  { value: 'PARENT_FEMALE', label: i18n.t('avatar.family.mother', 'Mother'), gender: 'FEMALE', relationship: 'PARENT' },
  {
    value: 'SIBLING_FEMALE',
    label: i18n.t('avatar.family.sister', 'Sister'),
    gender: 'FEMALE',
    relationship: 'SIBLING',
  },
  { value: 'CHILD_MALE', label: i18n.t('avatar.family.son', 'Son'), gender: 'MALE', relationship: 'CHILD' },
  {
    value: 'STEP_SIBLING_MALE',
    label: i18n.t('avatar.family.step-brother', 'Stepbother'),
    gender: 'MALE',
    relationship: 'STEP_SIBLING',
  },
  {
    value: 'STEP_CHILD_FEMALE',
    label: i18n.t('avatar.family.step-daughter', 'Stepdaughter'),
    gender: 'FEMALE',
    relationship: 'STEP_CHILD',
  },
  {
    value: 'STEP_PARENT_MALE',
    label: i18n.t('avatar.family.step-father', 'Stepfather'),
    gender: 'MALE',
    relationship: 'STEP_PARENT',
  },
  {
    value: 'STEP_GRANDCHILD_FEMALE',
    label: i18n.t('avatar.family.step-granddaughter', 'Step-granddaughter'),
    gender: 'FEMALE',
    relationship: 'STEP_GRANDCHILD',
  },
  {
    value: 'STEP_GRANDCHILD_MALE',
    label: i18n.t('avatar.family.step-grandson', 'Step-grandson'),
    gender: 'MALE',
    relationship: 'STEP_GRANDCHILD',
  },
  {
    value: 'STEP_PARENT_FEMALE',
    label: i18n.t('avatar.family.step-mother', 'Stepmother'),
    gender: 'FEMALE',
    relationship: 'STEP_PARENT',
  },
  {
    value: 'STEP_SIBLING_FEMALE',
    label: i18n.t('avatar.family.step-sister', 'Stepsister'),
    gender: 'FEMALE',
    relationship: 'STEP_SIBLING',
  },
  {
    value: 'STEP_CHILD_MALE',
    label: i18n.t('avatar.family.step-son', 'Stepson'),
    gender: 'MALE',
    relationship: 'STEP_CHILD',
  },
  { value: 'UNCLE', label: i18n.t('avatar.family.uncle', 'Uncle'), gender: 'MALE', relationship: 'UNCLE' },
  { value: 'SPOUSE_FEMALE', label: i18n.t('avatar.family.wife', 'Wife'), gender: 'FEMALE', relationship: 'SPOUSE' },
]

export default relationshipOptions
